import { render, staticRenderFns } from "./VisualizarUnidade.vue?vue&type=template&id=171dc1f0&scoped=true&"
import script from "./VisualizarUnidade.vue?vue&type=script&lang=js&"
export * from "./VisualizarUnidade.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarUnidade.vue?vue&type=style&index=0&id=171dc1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171dc1f0",
  null
  
)

export default component.exports